import { render, staticRenderFns } from "./CommissionBatch.vue?vue&type=template&id=574dce3c&"
import script from "./CommissionBatch.vue?vue&type=script&setup=true&lang=js&"
export * from "./CommissionBatch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CommissionBatch.vue?vue&type=style&index=0&id=574dce3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports